import {Injectable} from '@angular/core';
import {EcommerceDashboardPeriod, WebAccountService} from 'web-angular-client';
import {Helper} from '../../util/helper';
import {ISearchableService} from './ISearchableService';

@Injectable({
    providedIn: 'root'
})
export class EcommerceAccountSearchService implements ISearchableService
{
    /**
     * Optional period preset forwarded to the backend on the next search call. When set, the backend resolves it in
     * SAST and overrides the criteria's date-created bounds so the table aligns with the dashboard stats card.
     * Page components set this in their period-change handler; setting it to {@code null} reverts to caller-supplied
     * date bounds.
     */
    currentPeriod: EcommerceDashboardPeriod | null = null;

    constructor(private webAccountService: WebAccountService)
    {
    }

    search(pageNumber: number, pageSize: number, sortField: string, sortOrder: string, searchCriteria: any)
    {
        const criteria = {
            ...searchCriteria,
            amountUpper: Helper.convertToMinorDenomination(searchCriteria?.amountUpper)?.toString() ?? null,
            amountLower: Helper.convertToMinorDenomination(searchCriteria?.amountLower)?.toString() ?? null
        };

        const direction: 'ASC' | 'DESC' = sortOrder === 'ASC' ? 'ASC' : 'DESC';
        return this.webAccountService.searchEcommerceAccounts(
            pageNumber,
            pageSize,
            sortField,
            direction,
            this.currentPeriod ?? undefined,
            browserTimezone(),
            criteria);
    }
}

/** Browser's IANA timezone. Empty string if unavailable. */
export function browserTimezone(): string
{
    try
    {
        return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
    }
    catch
    {
        return '';
    }
}
